<template>
  <v-snackbar v-model="snackbar" color="#404040" :timeout="0" top auto-height>
    <!-- <span>Pre optimálnu funkčnosť a neustále vylepšovanie využívajú tieto stránky Cookies.</span> -->
    <span>Používaním týchto stránok vyjadrujete súhlas s využitím súborov cookies.</span>
    <v-btn @click="success" color="warning">Potvrdiť</v-btn>
  </v-snackbar>
</template>

<script>
import cookiesManager from "@/store/cookiesManager";
export default {
  name: "Header",
  data() {
    return {
      snackbar: false
    };
  },
  created() {
    // load from cookies
    let cookiesIsConfirmed = cookiesManager.getCookie("confirm-cookies");
    if (cookiesIsConfirmed) {
      this.snackbar = false;
    } else {
      this.snackbar = true;
    }
  },
  methods: {
    success() {
      cookiesManager.setCookie("confirm-cookies", "true", 30);
      this.snackbar = false;
    }
  }
};
</script>